import React from 'react';
import { Utils } from 'utils/UtilsDefault';
import cx from 'classnames';
import Input from './input/Input';

type Props = {
  mask?: any;
  maskChar?: any;
  input: any;
  meta?: any;
  readOnly?: any;
  formatChars?: any;
  autoComplete?: any;
  isDate?: any;
  validatefield?: any;
  disabled?: any;
};

const InputFormAdapter: React.FC<Props> = props => {
  const {
    mask,
    maskChar,
    input,
    meta,
    readOnly,
    formatChars,
    autoComplete = 'on',
    isDate = false,
    validatefield,
    ...rest
  } = props;

  let { value } = input;

  if (isDate && Utils.isValidDate(Utils.converterStringParaDate(value))) {
    value = Utils.retonaDiaEMesEAno(value);
  }

  const classNameFormGroup = cx('form-group-input', {
    'is-invalid':
      (meta.error || meta.submitError) && meta.touched && validatefield !== 'false',
    'is-valid':
      (!meta.error || !meta.submitError) &&
      meta.valid &&
      !meta.validating &&
      validatefield !== 'false',
    disabled: rest.disabled,
  });

  return (
    <Input
      input={input}
      {...rest}
      meta={meta}
      value={value}
      readOnly={readOnly}
      mask={mask}
      autoComplete={autoComplete}
      maskChar={maskChar || ''}
      formatChars={formatChars || null}
      className={classNameFormGroup}
      hasMask
      validatefield={validatefield}
    />
  );
};

export default InputFormAdapter;
